"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const translation_1 = require("../../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const LocalStorageKeys_1 = __importDefault(require("../../enums/LocalStorageKeys"));
const offerColumns_1 = require("../../helper/offerColumns");
const OfferStore_1 = __importDefault(require("../../stores/OfferStore"));
const TableTile_1 = __importDefault(require("../TableTile"));
const AssetsOfferTableExpandedItem_1 = __importDefault(require("./AssetsOfferTableExpandedItem"));
class AssetsOffer extends react_1.default.Component {
    contextReactionDisposer;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            offerId: mobx_1.computed,
        });
    }
    get offerId() {
        return this.props.match?.params?.offerId ?? null;
    }
    componentDidMount() {
        document.title = (0, translation_1.t)('myassets_subpage_title', { title: (0, translation_1.t)('myassets.offer.title') });
        this.contextReactionDisposer = (0, mobx_1.reaction)(() => AuthorizationStore_1.default.customerId, () => OfferStore_1.default.readOffers(), { fireImmediately: true });
    }
    componentWillUnmount() {
        this.contextReactionDisposer?.();
    }
    render() {
        if (OfferStore_1.default.isLoading) {
            return (react_1.default.createElement("section", { className: "znd-offers-table" },
                react_1.default.createElement(LoadingSpinner_1.default, { center: true })));
        }
        return (react_1.default.createElement("section", { className: "znd-offers-table" },
            react_1.default.createElement(TableTile_1.default, { columns: (0, offerColumns_1.getOffersOverviewColumns)(), data: OfferStore_1.default.offers, title: (0, translation_1.t)('myassets.offer.title'), localStorageKey: LocalStorageKeys_1.default.offerSort, expandableComponent: AssetsOfferTableExpandedItem_1.default, onExpandedRow: (row) => row.id === this.offerId, noDataText: (0, translation_1.t)('myassets.offer.table.no_data_text') })));
    }
}
exports.default = (0, react_router_dom_1.withRouter)((0, mobx_react_1.observer)(AssetsOffer));
